/**
 * Demo Mode Banner
 * Full-width amber banner displayed when the app is in demo mode
 */

import { makeStyles, tokens, Button } from '@fluentui/react-components'
import { Info16Regular } from '@fluentui/react-icons'
import { useExperienceMode } from '../context/ExperienceModeContext'

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXXL}`,
    backgroundColor: tokens.colorPaletteYellowBackground2,
    borderBottom: `1px solid ${tokens.colorPaletteYellowBorder1}`,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    color: tokens.colorPaletteYellowForeground2,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
  },
})

export function DemoModeBanner() {
  const { experienceMode, exitDemoMode } = useExperienceMode()
  const styles = useStyles()

  if (experienceMode !== 'demo') return null

  return (
    <div className={styles.banner} role="region" aria-label="Demo Mode Banner">
      <span className={styles.left} role="status" aria-live="polite">
        <Info16Regular aria-hidden="true" />
        Demo Mode — You are viewing sample issues
      </span>
      <Button appearance="subtle" size="small" onClick={exitDemoMode}>
        Return to My Issues
      </Button>
    </div>
  )
}
